<script>
import { mapGetters } from 'vuex';
import Constants from '../constants';

export default {
  methods: {
    color(c) {
      switch (c) {
        case 'indigo':
          return '#3A18D1';
        case 'pink':
          return '#FF1C80';
        case 'fourteenColors':
          return [
            '#3211C2',
            '#7B6AFF',
            '#DFE0F2',
            '#FF1C80',
            '#21B8C8',
            '#FF3900',
            '#ABD952',
            '#7BC5F9',
            '#FFA466',
            '#F7CD55',
            '#CE5AE3',
            '#F9A1D4',
            '#FFE504',
            '#EAECF2',
          ];
        case 'twelveColors':
          return [
            '#3211C2',
            '#7B6AFF',
            '#DFE0F2',
            '#FF1C80',
            '#21B8C8',
            '#FF3900',
            '#ABD952',
            '#7BC5F9',
            '#FFA466',
            '#F7CD55',
            '#CE5AE3',
            '#EAECF2',
          ];
        case 'elevenColors':
          return [
            '#3211C2',
            '#7B6AFF',
            '#DFE0F2',
            '#FF1C80',
            '#21B8C8',
            '#FF3900',
            '#ABD952',
            '#7BC5F9',
            '#FFA466',
            '#F7CD55',
            '#EAECF2',
          ];
        case 'tenColors':
          return [
            '#3211C2',
            '#7B6AFF',
            '#DFE0F2',
            '#FF1C80',
            '#21B8C8',
            '#FF3900',
            '#ABD952',
            '#7BC5F9',
            '#FFA466',
            '#EAECF2',
          ];
        case 'nineColors':
          return [
            '#3211C2',
            '#7B6AFF',
            '#DFE0F2',
            '#FF1C80',
            '#21B8C8',
            '#FF3900',
            '#ABD952',
            '#7BC5F9',
            '#EAECF2',
          ];
        case 'eightColors':
          return [
            '#3211C2',
            '#7B6AFF',
            '#DFE0F2',
            '#FF1C80',
            '#21B8C8',
            '#FF3900',
            '#ABD952',
            '#EAECF2',
          ];
        default:
          return '#3A18D1';
      }
    },
  },

  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesCollectives/neopassDatas',
    }),

    hasInformationsGeneralesData() {
      return (
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES] &&
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length > 0
      );
    },

    /**
     * Men/Women breakdown
     */
    gender: function () {
      const infosGeneralForEachBeneficiary =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES] ||
        [];

      if (infosGeneralForEachBeneficiary.length === 0) {
        return {};
      }

      let labels = ['Femmes', 'Hommes', 'Non-binaire', 'Non précisé'];

      const totalBeneficiaries = infosGeneralForEachBeneficiary.length;

      let datas = infosGeneralForEachBeneficiary.reduce(
        (acc, benficiary) => {
          return {
            male: acc.male + (benficiary.genre == 'Homme' ? 1 : 0),
            female: acc.female + (benficiary.genre == 'Femme' ? 1 : 0),
            noBinary:
              acc.noBinary + (benficiary.genre == 'Non-binaire' ? 1 : 0),
          };
        },
        { male: 0, female: 0, noBinary: 0 }
      );

      let notDefined =
        totalBeneficiaries - (datas.male + datas.female + datas.noBinary);

      return {
        longLabels: labels,
        datas: [datas.female, datas.male, datas.noBinary, notDefined],
      };
    },

    /**
     * Age by gender
     */
    age: function () {
      //Age intervals
      let labels = [
        '15-19',
        '20-24',
        '25-29',
        '30-34',
        '35-39',
        '40-44',
        '45-49',
        '50-54',
        '55-59',
        '60-64',
        '65-69',
      ];

      //data structure for women ages
      let female = {
        label: 'Femmes',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        backgroundColor: this.color('pink'),
      };
      //data structure for men ages
      let male = {
        label: 'Hommes',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        backgroundColor: this.color('indigo'),
      };
      //data structure for no gender ages
      let notDefined = {
        label: 'Non précisé',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      };

      this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].forEach((data) => {
        if (data != null && data != undefined) {
          if (data.date_naissance != null && data.date_naissance != undefined) {
            //Calculte age by birthday
            let age = new Number(
              (new Date().getTime() - new Date(data.date_naissance).getTime()) /
                31536000000
            ).toFixed(0);
            let ageIndex = -1;

            //determine which case fill in data age for each gender
            switch (true) {
              case age >= 15 && age < 20:
                ageIndex = 0;
                break;
              case age >= 20 && age < 25:
                ageIndex = 1;
                break;
              case age >= 25 && age < 30:
                ageIndex = 2;
                break;
              case age >= 30 && age < 35:
                ageIndex = 3;
                break;
              case age >= 35 && age < 40:
                ageIndex = 4;
                break;
              case age >= 40 && age < 45:
                ageIndex = 5;
                break;
              case age >= 45 && age < 50:
                ageIndex = 6;
                break;
              case age >= 50 && age < 55:
                ageIndex = 7;
                break;
              case age >= 55 && age < 60:
                ageIndex = 8;
                break;
              case age >= 60 && age < 65:
                ageIndex = 9;
                break;
              case age >= 65 && age < 70:
                ageIndex = 10;
                break;
              default:
                break;
            }

            //Fill the case corresponded for women, men and no gender
            if (data.genre == 'Femme') female.data[ageIndex] += 1;
            if (data.genre == 'Homme') male.data[ageIndex] += 1;
            if (data.genre != 'Femme' && data.genre != 'Homme')
              notDefined.data[ageIndex] += 1;
          }
        }
      });

      return {
        longLabels: labels,
        datas: [female, male, notDefined],
      };
    },

    handicap: function () {
      //List of different handicap types
      let labels = [
        'Handicap Intellectuel et difficultés de comportement',
        'Handicap psychique',
        'Handicap du Langage et de la Parole',
        'Handicap Auditif',
        'Handicap Visuel',
        'Handicap Viscéral et général',
        'Handicap Moteur et troubles associés',
        'Maladies invalidantes',
        'Autres handicaps',
        'Non précisé',
      ];
      //Retrieve handicap informations for beneficiaries who have handicap
      let listNeopassHandicap = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].filter((p) => p.travailleur_handicape);
      //init values
      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      listNeopassHandicap.forEach((data) => {
        if (data) {
          if (data.handicap && data.handicap.length > 0) {
            data.handicap.forEach((handicap) => {
              datas[
                Object.keys(labels).find((key) => labels[key] === handicap)
              ] += 1; //Add 1 in array datas where key match with key in listNeopassHandicap array
            });
          }
        }
      });

      datas[labels.length - 1] =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length - datas.reduce((acc, d) => acc + d, 0);

      return {
        longLabels: labels,
        datas: datas,
      };
    },

    formations: function () {
      let labels = [
        'Niveau 3 - CAP, BEP',
        'Niveau 4 - Baccalauréat',
        'Niveau 5 - DEUG, BTS, DUT, DEUST',
        'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1',
        "Niveau 7 - Master, diplôme d'études approfondies, diplôme d'études supérieures spécialisées, diplôme d'ingénieur",
        'Niveau 8 - Doctorat, habilitation à diriger des recherches',
        'Autre',
        'Aucun',
        'Non précisé',
      ];
      let shortLabels = ['', '', '', '', '', '', '', '', ''];
      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].forEach((data) => {
        if (data != null) {
          if (data.niveau == 'Aucun') {
            datas[labels.length - 2] += 1;
          } else if (data.niveau != null && labels.includes(data.niveau)) {
            datas[
              Object.keys(labels).find((key) => labels[key] === data.niveau)
            ] += 1; //Add 1 in array datas where key match with key in listFormations array
          } else {
            datas[labels.length - 1] += 1;
          }
        }
      });
      return {
        shortLabels: shortLabels,
        longLabels: labels,
        datas: [
          {
            label: 'Formations',
            data: datas,
            backgroundColor: this.color('nineColors'),
          },
        ],
      };
    },

    situationAnterieure: function () {
      let labels = [
        "Demandeur d'Emploi",
        'Scolarité classique ou Formation',
        'Institution ou Service Spécialisé (IME, SIPFP, IES, IEM...)',
        "Service d'Accompagnement Social (SSAD, SESSAD, SAVS...)",
        "Etablissement et Service d'Aide par le Travail (ESAT)",
        'Entreprise Adaptée (EA)',
        'Centre de Distribution de Travail à Domicile (CDTD)',
        "Entreprise d'Insertion (EI)",
        'Entreprise de Travail Temporaire (ETT, ETTI)',
        'Milieu Ordinaire / Handicap',
        'Milieu Ordinaire / Inaptitude',
        'Institution Sanitaire (CHR, CHS, CRF...) / Hospitalisation',
        'Autre',
        'Non précisé',
      ];
      let shortLabels = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ];
      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].forEach((data) => {
        if (data != null) {
          if (
            data.situation_anterieure != null &&
            labels.includes(data.situation_anterieure)
          ) {
            datas[
              Object.keys(labels).find(
                (key) => labels[key] === data.situation_anterieure
              )
            ] += 1; //Add 1 in array datas where key match with key in listFormations array
          } else {
            datas[labels.length - 1] += 1;
          }
        }
      });
      return {
        shortLabels: shortLabels,
        longLabels: labels,
        datas: [
          {
            label: 'Situation antérieure',
            data: datas,
            backgroundColor: this.color('fourteenColors'),
          },
        ],
      };
    },

    tempsTravail: function () {
      const infosForEachBeneficiary =
        this.neopassDatas[
          Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE
        ] || [];

      const totalBeneficiaries =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length;

      if (totalBeneficiaries === 0) {
        return {};
      }

      let labels = ['Temps partiel', 'Temps plein', 'Non précisé'];

      let datas = infosForEachBeneficiary.reduce(
        (acc, data) => {
          return {
            partiel:
              acc.partiel + (data.temps_travail == 'Temps partiel' ? 1 : 0),
            plein: acc.plein + (data.temps_travail == 'Temps plein' ? 1 : 0),
          };
        },
        { partiel: 0, plein: 0 }
      );

      let notDefined = totalBeneficiaries - (datas.partiel + datas.plein);

      return {
        longLabels: labels,
        datas: [datas.partiel, datas.plein, notDefined],
      };
    },

    contrats: function () {
      let labels = [
        "Contrat de soutien et d'aide par le travail",
        'Contrat de travail à durée indéterminée',
        'Contrat de travail à durée déterminée',
        "Contrat d'apprentissage",
        'Contrat de professionnalisation',
        'Contrat de travail intérimaire',
        "Contrat unique d'insertion - Secteur privé",
        "Contrat unique d'insertion - Secteur public",
        'Autres contrats',
        'Non précisé',
      ];
      let shortLabels = [
        'CSAT',
        'CDI',
        'CDD',
        'CA',
        'CP',
        'Intérim',
        'CUI privé',
        'CUI public',
        'Autres',
        'Non précisé',
      ];

      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const totalBeneficiaries =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length;
      if (
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE]
      ) {
        this.neopassDatas[
          Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE
        ].forEach((data) => {
          if (data != null) {
            if (
              data.type_contrat != null &&
              labels.includes(data.type_contrat)
            ) {
              datas[
                Object.keys(labels).find(
                  (key) => labels[key] === data.type_contrat
                )
              ] += 1;
            } else {
              datas[labels.length - 1] += 1;
            }
          }
        });
      }

      //calculate "non précisé" volume
      datas[labels.length - 1] =
        totalBeneficiaries - datas.reduce((acc, d) => acc + d, 0);

      return {
        longLabels: labels,
        shortLabels: shortLabels,
        datas: datas,
      };
    },

    remuneration: function () {
      let moyenne;
      let values = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE
      ]
        ? this.neopassDatas[
            Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE
          ].filter((p) => p.remuneration != '' && p.remuneration != null)
        : [];
      let total = values.length;
      let min = 0;
      let max = 0;
      let sum = 0;

      values.forEach((v) => {
        if (v.remuneration != null) {
          if (v.remuneration >= max) {
            max = v.remuneration;
          }
          if (v.remuneration < min || min == 0) {
            //manage case min = 0
            min = v.remuneration;
          }
          sum += v.remuneration;
        }
      });

      if (sum > 0) {
        moyenne = sum / total;
      } else {
        moyenne = 0;
      }

      return {
        min: min,
        max: max,
        moyenne: moyenne,
      };
    },

    hebergement: function () {
      let labels = [
        'Structure Hébergement',
        'Appartement Collectif',
        'Famille',
        "Famille d'accueil",
        'Logement personnel avec accompagnement (type SAVS)',
        'Logement personnel sans accompagnement',
        'Autres (hôpital, sans domicile...)',
        'Non précisé',
      ];
      let shortLabels = [
        'Structure',
        'Appart. collectif',
        'Famille',
        "Famille d'accueil",
        'Personnel(SAVS)',
        'Personnel',
        'Autres',
        'Non précisé',
      ];

      let datas = [0, 0, 0, 0, 0, 0, 0, 0];
      this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].forEach((data) => {
        if (data != null) {
          if (data.hebergement != null && labels.includes(data.hebergement)) {
            datas[
              Object.keys(labels).find(
                (key) => labels[key] === data.hebergement
              )
            ] += 1;
          } else {
            datas[labels.length - 1] += 1;
          }
        }
      });
      return {
        longLabels: labels,
        shortLabels: shortLabels,
        datas: datas,
      };
    },

    mobilite: function () {
      let labels = [
        'Aucun',
        'Voiture',
        'Moto',
        'Scooter',
        'Vélo',
        'Marche',
        'Train',
        'Bus',
        'Tran. en commun',
        'Autres',
        'Non précisé',
      ];
      let shortLabels = ['', '', '', '', '', '', '', '', '', ''];
      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].forEach((data) => {
        if (data != null) {
          if (data.moyen_transport != null && data.moyen_transport.length > 0) {
            data.moyen_transport.forEach((moyen) => {
              if (labels.includes(moyen)) {
                datas[
                  Object.keys(labels).find((key) => labels[key] === moyen)
                ] += 1; //Add 1 in array datas where key match with key in listFormations array
              }
            });
          } else {
            datas[labels.length - 1] += 1;
          }
        }
      });
      return {
        longLabels: labels,
        shortLabels: shortLabels,
        datas: [
          {
            label: 'Moyen de transport',
            data: datas,
            backgroundColor: this.color('elevenColors'),
          },
        ],
      };
    },

    reconnaissance: function () {
      let labels = [
        'Aucune',
        'Reconnaissance travailleur handicapé délivrée par la CDAPH',
        "Titulaire d'une rente d'accident du travail ou d'une maladie professionnelle",
        "Titulaire d'une pension d'invalidité",
        'Pensionné de guerre ou assimilé',
        "Titulaire de l'allocation adulte handicapé",
        "Titulaire de la carte d'invalidité",
        'Autre catégorie (Mutilé de guerre, assimilé mutilé de guerre, sapeur pompier volontaire)',
        'Non précisé',
      ];
      let shortLabels = ['', '', '', '', '', '', '', '', ''];
      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

      this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES
      ].forEach((data) => {
        if (data != null) {
          if (data.lourdeur_handicap == 'Oui') {
            if (data.statut != null && labels.includes(data.statut)) {
              datas[
                Object.keys(labels).find((key) => labels[key] === data.statut)
              ] += 1; //Add 1 in array datas where key match with key in listFormations array
            }
          }
        }
      });

      datas[labels.length - 1] =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length - datas.reduce((acc, d) => acc + d, 0);

      return {
        longLabels: labels,
        shortLabels: shortLabels,
        datas: [
          {
            label: 'Reconnaissance de handicap',
            data: datas,
            backgroundColor: this.color('nineColors'),
          },
        ],
      };
    },

    statut: function () {
      let labels = [
        'Usager',
        "Salarié handicapé bénéficiant de l'aide au poste",
        'Salarié valide',
        "Salarié handicapé ne bénéficiant pas de l'aide au poste",
        'Intérimaire',
        'Stagiaire',
        'Autre',
        'Non précisé',
      ];
      let shortLabels = ['', '', '', '', '', '', '', ''];
      let datas = [0, 0, 0, 0, 0, 0, 0, 0];

      const totalBeneficiaries =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length;

      if (
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE]
      ) {
        this.neopassDatas[
          Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE
        ].forEach((data) => {
          if (data != null) {
            if (data.statut2 && labels.includes(data.statut2)) {
              datas[
                Object.keys(labels).find((key) => labels[key] === data.statut2)
              ] += 1; //Add 1 in array datas where key match with key in listFormations array
            } else {
              datas[labels.length - 1] += 1;
            }
          }
        });
      }

      //calculate "non précisé" volume
      datas[labels.length - 1] =
        totalBeneficiaries - datas.reduce((acc, d) => acc + d, 0);

      return {
        longLabels: labels,
        shortLabels: shortLabels,
        datas: [
          {
            label: 'Statut',
            data: datas,
            backgroundColor: this.color('eightColors'),
          },
        ],
      };
    },

    qualification: function () {
      let labels = [
        'Manoeuvres',
        'Ouvriers non qualifiés',
        'Ouvriers qualifiés',
        'Employés non qualifiés',
        'Employés qualifiés',
        'Techniciens',
        'Ingénieurs et cadres',
        'Autres',
        'Non précisé',
      ];
      let shortLabels = ['', '', '', '', '', '', '', '', ''];
      let datas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

      const totalBeneficiaries =
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES]
          .length;

      if (
        this.neopassDatas[Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE]
      ) {
        this.neopassDatas[
          Constants.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE
        ].forEach((data) => {
          if (data != null) {
            if (data.qualification && labels.includes(data.qualification)) {
              datas[
                Object.keys(labels).find(
                  (key) => labels[key] === data.qualification
                )
              ] += 1; //Add 1 in array datas where key match with key in listFormations array
            } else {
              datas[labels.length - 1] += 1;
            }
          }
        });
      }

      //calculate "non précisé" volume
      datas[labels.length - 1] =
        totalBeneficiaries - datas.reduce((acc, d) => acc + d, 0);

      return {
        longLabels: labels,
        shortLabels: shortLabels,
        datas: [
          {
            label: 'Qualification',
            data: datas,
            backgroundColor: this.color('nineColors'),
          },
        ],
      };
    },
  },
};
</script>
